;(function () {
  'use strict'

  angular
    .module('contrast.auth')
    .factory('AuthCookieService', AuthCookieService)

  function AuthCookieService(atob, $cookies, CONTRAST_UI_KEY) {
    'ngInject'

    return {
      isSessionActive: isSessionActive,
      getSessionExpiration: getSessionExpiration
    }

    /**
     * @returns {{}}
     */
    function getCookie() {
      var raw, stripped, decoded, parsed

      raw = $cookies.get(CONTRAST_UI_KEY)
      if (angular.isString(raw)) {
        stripped = raw.replace(/"/g, '')
        decoded = atob(stripped)
        parsed = angular.fromJson(decoded)
      }

      return angular.isObject(parsed) ? parsed : {}
    }

    function isSessionActive() {
      return !isSessionExpired(getCookie())
    }

    function isSessionExpired(cookieValue) {
      if (
        cookieValue.lastActivity &&
        cookieValue.idleTimeout !== undefined &&
        cookieValue.absoluteTimeout !== undefined
      ) {
        return (
          isDateExpired(cookieValue.start, cookieValue.absoluteTimeout) ||
          isDateExpired(cookieValue.lastActivity, cookieValue.idleTimeout)
        )
      }
      return true
    }

    function isDateExpired(date, timeout) {
      return timeout !== 0 && moment().diff(moment(date)) / 1000 > timeout
    }

    function getSessionExpiration() {
      var cookieVal = getCookie(),
        idleExpiration = 0,
        absoluteExpiration = 0

      if (
        cookieVal.lastActivity &&
        cookieVal.idleTimeout &&
        cookieVal.absoluteTimeout
      ) {
        idleExpiration = moment(cookieVal.lastActivity)
          .add(cookieVal.idleTimeout, 's')
          .diff(moment())
        absoluteExpiration = moment(cookieVal.start)
          .add(cookieVal.absoluteTimeout, 's')
          .diff(moment())

        return Math.min(idleExpiration, absoluteExpiration)
      }

      return 0
    }
  }
})()
